/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useContext } from 'react'

import { useNavigate } from "react-router-dom";
import {
    Drawer as MUIDrawer,
    List,
    Avatar
} from "@material-ui/core";
import "./drawer.css";
import Popup from '../popup/Popup';
import getGlobalVarContext from "../context/getGlobalVarContext";
import { useIntl } from 'react-intl';
import common from "../config/common.json"
function Drawer() {
    const { setGlobalVar, globalVar } = useContext(getGlobalVarContext());
    const { groupUserList, isRightSideBarOpen } = globalVar
    const navigate = useNavigate();
    const intl = useIntl()
    const Logout = () => {
        setGlobalVar((oldData) => ({
            ...oldData,
            data: {},
            renderView: false,
            pubnub: "",
            personalChannel:[],
            groupList: [],
            subID: null,
            email: null,
            groupUserList:[],
            newPersonalsearchList: [],
            newGroupsearchList:[],
            userDetalis: null,
            page: true,
            isRightSideBarOpen: false,
        }));
        localStorage.removeItem("token")
        localStorage.removeItem("refreshToken")
        localStorage.removeItem("email")
        localStorage.removeItem("name")
        localStorage.removeItem("phone_number")
        localStorage.removeItem("sub")
        localStorage.removeItem("k_phone_number")
        localStorage.removeItem("last_name")
        localStorage.removeItem("sip_id")
        localStorage.removeItem("profile_url")
        localStorage.removeItem("openDrw")
        localStorage.removeItem("profile_user")
        navigate('/');
    }

    const [buttonOpen, setButtonOpen] = useState(false);
    var profile_url = ""
    if (localStorage.getItem("profile_user") !== null && localStorage.getItem("profile_user") !== undefined) {
        profile_url = localStorage.getItem("profile_user")
    }
    var listUsermember = 0;
    if (groupUserList.length === 0) {
        listUsermember = 0;
    } else {
        listUsermember = groupUserList.length;

    }
    return (
        <div variant="permanent" className='mainclassname'>
            <div className='profile_header' >
                <div className='mainDrawerAvatar'>
                    <div style={{ margin: "auto" }}>
                        <Avatar className='drawerAvatar' src={profile_url} >{intl.formatMessage({ id: "drawerAvatar" })}</Avatar>
                    </div>
                    <div className='drawerMainTitleBlock'>
                        <div className='listingDiv'>
                            <p >{localStorage.getItem("name")}</p>

                        </div>
                        <a className='cursorpointer' onClick={() => setButtonOpen(true)} style={{ color: "gray" }}>{intl.formatMessage({ id: "manageAccount" })}</a>
                    </div>
                </div>
                <h3 className='close' onClick={() => {
                    setGlobalVar((oldState) => ({ ...oldState, isRightSideBarOpen: !isRightSideBarOpen }))
                }} >{intl.formatMessage({ id: "closeButton" })}</h3>
            </div>
            <div className='scrollBar'>
                {localStorage.getItem("groupType") === "true" ?
                    <p style={{ marginTop: "40px", marginBottom: "20px" }}>{intl.formatMessage({ id: "groupMemberListMsg" }, { name: listUsermember })}
                    </p> : ""}
                <div >
                    {groupUserList.map((item, index) => {
                        var name = item.user_name === localStorage.getItem("name") ? item.friend_name : item.friend_name === localStorage.getItem("name") ? item.user_name : item.user_name
                        var profile = item.user_id === localStorage.getItem("sub") ? item.friend_url : item.user_url

                        return (
                            <div className='gropuMember'>
                                <div>

                                    <Avatar key={index} src={profile} style={{ background: profile === intl.formatMessage({ id: "profileUrlType" }) || profile === intl.formatMessage({ id: "profileUrlType1" }) ? common.autoColorGenerator[Math.floor(Math.random() * common.autoColorGenerator.length)] : "#bdbdbd" }}>{intl.formatMessage({ id: "drawerAvatar" })}</Avatar>
                                </div>
                                <div>
                                    <p style={{ color: "gray", paddingLeft: "20px" }}>{name}</p>
                                </div>
                            </div>

                        );
                    })}
                </div>
            </div>
            <div className='logout_container'>
                <p className='cursorpointer' onClick={Logout} style={{ color: "red", marginTop: "5px" }}>{intl.formatMessage({ id: "logoutLink" })}</p>
            </div>
            <Popup trigger={buttonOpen} setTrigger={setButtonOpen}>
                </Popup>
        </div>
    )
}
export default Drawer